export default [
  {
    text: 'Débito',
    value: 'cartaoDebito',
  },
  {
    text: 'Crédito',
    value: 'cartaoCredito',
  },
  {
    text: 'Crédito parcelado',
    value: 'cartaoCreditoParcelado',
  },
  {
    text: 'Pix',
    value: 'pix',
  },
  {
    text: 'Pré-Pago',
    value: 'prePago',
  },
  {
    text: 'Pós-Pago',
    value: 'posPago',
  },
];
